var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75.4 73.4",
    style: {
      enableBackground: "new 0 0 75.4 73.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5,30.9L31.5,30.9c1.1-0.7,2.5-0.3,3.2,0.8l3.3,5.3c0.1-0.6,0.5-1.1,1-1.5h0c1-0.6,2.3-0.4,3,0.5 c0.1-0.7,0.4-1.4,1.1-1.8l0,0c1-0.6,2.3-0.4,3,0.5c0.1-0.7,0.4-1.4,1.1-1.8h0c1.1-0.7,2.6-0.4,3.2,0.8l4.5,8.2 c3.7,6.7-3.4,15.3-10.5,11.9L32,47.9c-1.2-0.5-1.6-1.9-1.1-3.1c1.1-0.7,3.4-1,4.5-0.4l2.3,1.1l-7-11.4C30,33,30.4,31.6,31.5,30.9 L31.5,30.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1,38.8c-2.6-0.9-4.5-3.4-4.5-6.3c0-3.7,3-6.7,6.7-6.7c3.4,0,6.1,2.5,6.6,5.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4,43.1c-4-1.9-6.8-5.9-6.8-10.7c0-6.5,5.3-11.8,11.8-11.8c5.5,0,10,3.7,11.4,8.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogout);
export default __webpack_public_path__ + "static/media/ico-logout.ebae8c10880674b19fea19b800eda152.svg";
export { ForwardRef as ReactComponent };